export enum Information {
  HazardousGoodsRequested = 'You must send the hazardous goods document(s) to your local booking office for approval prior to unit arriving at the port. Hazardous goods arriving at the ports without prior approval will be subject to an additional charge.',
  HazardousGoodsRequestedShort = 'Please send hazardous goods document(s) to your local Stena Line office prior to departure.',
  HazardousGoodsApproved = 'Hazardous goods have been approved. Documentation has been added to the booking.',
  HazardousGoodsApprovedLimitedEdit = 'Hazardous goods have been approved. Documentation has been added to the booking. Editing is limited.',
  LoadingPreferenceRequested = 'Your loading preference request will be handled by Stena Line.',
  LoadingPreferenceApproved = 'Your loading preference request has been approved',
  LoadingPreferenceRejected = 'Unfortunately your requested loading preference is not available on the selected departure',
  LoadingPreferenceNotApplicable = 'Unfortunately your requested loading preference is not available on the selected departure (not applicable)',
  CraneableRequested = 'Your craneable request will be handled by Stena Line.',
  CraneableApproved = 'Your craneable request has been approved',
  CraneableRejected = 'Unfortunately your craneable request is not available on the selected departure',
  CraneableNotApplicable = 'Unfortunately your craneable request is not available on the selected departure (not applicable)',
  AnimalsInformation = 'Special handling of this vehicle is required. Please advise details of the animal(s) to your local booking office as soon as possible.',
  Plugin = 'For different temperatures, use the format: +4 / -10 °C. Please note that your plugin request refers to the ship voyage only.',
  IntermodalInProgress = 'This booking request is waiting to be confirmed by Stena Line staff. Bookings are handled during office hours (Monday - Friday 07-18).',
  IntermodalUpdated = 'The updates on this booking are waiting to be confirmed by Stena Line staff. Bookings are handled during office hours (Monday - Friday 07-18).',
  IntermodalCreate = 'This booking request will be handled by Stena Line staff during office hours (Monday - Friday 07-18).',
  TimetableNoSailingsThisDay = 'There are no sailings this day',
  TimetableSelectRoute = 'Please select a route',
  TimetableNoSailingsFound = 'No sailings found',
  FormHasUnsavedChanges = 'You have unsaved changes',
  AddMobileForSmsNotifications = 'Please add a mobile number to receive SMS notifications',
  SailingNotificationsInfo = 'You will receive these notifications for all sailings where you have units booked.',
  PaymentProcessingDelayed = 'Processing the payment took longer than expected',
  BookingReloadedDueToModification = 'Reloaded the page because the booking was modified by someone else.',
  HazardousGoodsConfirmedPayableOnline = 'Once the hazardous goods are confirmed the booking can be paid online.',
  ChangesSaved = 'Your changes were saved',
  NoValidCustomers = 'You have no account with booking privileges. Contact Stena Line to set up an account.',
  NewVersionAvailable = 'A new version of Freight Portal is available. Click Reload to get the latest version.',
  GoodsDescriptionEnsHint = 'If ENS is not submitted through Stena Line, the goods description you provide will be sent to customs.',
  PaymentSuccessfullyPaid = 'The booking has been paid successfully',
  PaymentPartiallyPaid = 'The booking is partially paid',
  PaymentRefunded = 'The payment has been refunded',
  LoadingPaymentDetails = 'Loading payment details...',
  NoBookingSelectedForPayment = 'It seems you have not selected a booking to pay.',
  NoBookingNumberHeader = 'No booking number',
  PasswordChanged = 'Password successfully changed.',
  ShareBookingMessageSentTo = 'Message sent to:',

  // TODO: NoCargoOptions used verbatim in CargoGoodsSection and CargoGoodsDetailsSection.
  NoCargoOptions = 'There are no cargo options available.',
  GatePhotosNotAvailable = 'Gate photos are not available for this port',
  NoPhotosAvailableForUnit = 'There are no photos available for this unit',
  SearchPlaceholderHint = 'Type to search for booking numbers, vehicle and trailer registration numbers, and customer references',
  SearchNoResults = 'Your search query did not give any results. Try searching for something else',

  RefreshKeepUpToDateTitle = 'Keep up to date with your bookings!',
  RefreshReloadForAccuracy = 'Reload the page to make sure that the booking information is accurate',

  DragToReorderColumns = 'Drag and drop to change order of the columns',

  IntermodalStatisticsOnlyFerry = 'For intermodal bookings, only the ferry routes are included in the statistics.',
  IntermodalSettingsNotApplicable = 'These settings do not apply to intermodal bookings.',
  // TODO: prefix only — booking number is interpolated at the call site (BookingDetailsViewContent.tsx).
  PartOfIntermodalBookingPrefix = 'This booking is part of intermodal booking',

  // TODO: prefix/suffix pair — date is interpolated between the two halves at the call site (AutoCancellationInfoBanner.tsx).
  AutoCancellationBeforeDatePrefix = 'This booking must be completed with a registration number before',
  AutoCancellationBeforeDateSuffix = '(local time at departure port). Otherwise, it will be cancelled.',

  // TODO: HazardousGoodsListed and NoHazardousGoodsDocumentation are concatenated with ContactOfficeForQuestionsSuffix at the call site (HazardousGoodsPane.tsx).
  HazardousGoodsListed = 'The following hazardous goods have been added to the booking.',
  NoHazardousGoodsDocumentation = 'No hazardous goods documentation has been added to the booking.',
  ContactOfficeForQuestionsSuffix = ' Please contact your local Stena Line booking office if you have any questions.',

  ContactingCustomsLink = 'Contacting CustomsLink',
  CustomsLinkSignupHeading = 'Easy customs handling at CustomsLink',
  CustomsLinkSignupIntro = "Sign up at Stena Line's partner CustomsLink to speed up and keep track of your customs process.",
  CustomsLinkSignupBenefits = 'Get your Goods movement reference (GMR) or Pre-boarding notification (PBN) and Portbase Notification Export Documentation (NED) in minutes.',
  CustomsLinkSignupCta = 'Sign up and go to CustomsLink',
  // TODO: the rest of the GDPR modal body is left inline in CustomsLinkGdprModal.tsx because it has interleaved <Link> elements.

  // TODO: BookingNotSavedTitle and ChangesNotSavedBody are paired in ErrorIconWithPopup.tsx.
  BookingNotSavedTitle = 'Booking not saved',
  ChangesNotSavedBody = 'Your changes were not saved.',

  AccessDeniedTitle = 'Access denied',
  NoPermissionToAccessPage = "Sorry, but you don't have permission to access this page.",
  NoAccessToFeatureHeading = 'You do not have access to this feature',

  AuthLoginFailedHeading = 'Sorry, we could not log you in',
  AuthLoginFailedBody = 'We were not able to log you in to Freight Portal. Please try again.',
  AuthTimeoutHeading = "Time's up",
  AuthTimeoutBody = 'The request took too long and we could not log you in. Refresh the page and try again.',
  AuthTimingHeading = "We're sorry about the timing",
  AuthTimingExplanation = 'Since we only support a few minutes of time difference between systems we are not able to log you in to Freight Portal. If you update the time on your computer it should work just fine.',
  AuthTimingWindowsHelpHeader = 'Update the time on a Windows computer',
  // TODO: numbered Windows time-sync steps below are tightly coupled — they only make sense as a sequence rendered together (AuthErrorBody.tsx).
  AuthTimingStep1 = '1. Open Control Panel.',
  AuthTimingStep2 = '2. Click on Clock, Language, and Region.',
  AuthTimingStep3 = '3. Click on Date and Time.',
  AuthTimingStep4 = '4. Click on the Internet Time tab.',
  AuthTimingStep5 = '5. Click the Change settings button.',
  AuthTimingStep6 = '6. Check that the Synchronize with an internet time server option is selected.',
  AuthTimingStep7 = '7. Use the drop-down menu to select a different server.',

  // TODO: shown alongside Errors.UnexpectedProblem in ErrorBoundaryForFeature.tsx.
  FeatureBoundaryReloadHint = 'Try to reload the page to resolve the issue.',

  // TODO: descriptions paired with notification toggles in subscriptions/*.tsx.
  DepartureSummaryDescription = 'Receive a summary of your shipped units when the ship departs',
  ArrivalTimeChangedDescription = 'There is a change in the estimated time of arrival',
  NoShowDescription = 'The unit did not show up in time for the sailing',
  LateCancellationDescription = 'Your booking was cancelled too close to the sailing time',
  BookingConfirmationDescription = 'For bookings created or updated by you',
  CheckInDeviationDescription = 'Booking details are changed at check-in',

  // TODO: descriptions paired with dashboard setting toggles in DashboardSettings.tsx.
  DashboardOverviewDescription = 'The dashboard provides an overview and a collection of shortcuts to apply filters to your bookings.',
  DashboardShowNotCheckedInDescription = 'Show bookings that are not checked-in.',
  DashboardNotCheckedInTimeDescription = 'Time to departure when a unit will appear as "Not checked-in".',
  DashboardShowPendingApprovalDescription = 'Show bookings that have a pending request for hazardous goods or loading preference.',
  DashboardShowDateOverviewDescription = 'Show all bookings for today and tomorrow that have not been cancelled.',
  DashboardShowUnaccompaniedUnitsDescription = 'Show unaccompanied units that are arriving to, or standing on, quay.',
  DashboardShowDashboardOnScrollDescription = 'The dashboard will stay on the screen even when you scroll down.',

  // TODO: vehicle reg number is prepended at the call site (TravelledVehicleResult.tsx).
  VehicleShippedBeforeSuffix = 'has been shipped before. Do you want to use this information?',
}

export enum Errors {
  SelectGoodsType = 'Select a goods type',
  EnterGoodsDescription = 'Enter goods description',
  EnterGoodsWeight = 'Enter goods weight',
  SelectDepartureTime = 'Select a departure time',
  SelectDepartureDate = 'Select a departure date',
  RequestFailed = 'The create request failed',
  TimetableNoData = 'Sorry, we were not able to find any data. Please try again later.',
  FormHasErrors = 'There was a problem. Please review your changes and try again.',
  UnexpectedProblem = 'Unfortunately we encountered an unexpected problem',
  CouldNotGetPaymentDetails = 'Could not get payment details',
  CouldNotFindBooking = 'Could not find booking',
  PhoneNumberInvalidFormat = 'Only numbers and dash are allowed',
  ShareBookingFailed = 'An error occurred, could not share the booking.',
  NoRateAgreementForRoute = 'No rate agreement found for this route.',
  DownloadExcelFailed = 'Could not download Excel sheet.',
  BookingCreationValidationProblem = 'There was a problem. Please review your information and try again.',
  BookingNotAdded = 'No booking was added. Unfortunately an error occurred during saving.',
  PasswordSaveFailed = 'Could not save password.',
  PasswordsDoNotMatch = 'The new password and confirmation password do not match.',
  NewPasswordSameAsOld = 'The new password cannot be the same as the old password.',
  MandatoryFieldsMissing = 'All mandatory fields are not filled out.',
  PasswordRequirementsNotMet = 'Your new password does not meet the minimum requirements',
  ServerTemporarilyOutOfService = 'Temporarily out of service',
  ErrorOccurred = 'An error occurred',
  UnexpectedProblemReloadHint = 'Unfortunately we encountered an unexpected problem. Please try to reload the page.',

  // TODO: four "Something went wrong" wordings — consider unifying.
  SomethingWentWrong = 'Something went wrong',
  SomethingWentWrongTryAgain = 'Something went wrong, please try again.',
  SomethingWentWrongTryAgainLater = 'Something went wrong. Please try again later.',
  SomethingWentWrongFetchingResults = 'Something went wrong when fetching results:',
  ServerConnectionProblem = 'There seems to be a problem with the connection to the server. Please try again later.',
  SaveFailedReviewChanges = 'Save failed. Please review your changes and try again.',

  BookingNotFound = 'We cannot find this booking',
  // TODO: similar wording to Information.ContactOfficeForQuestionsSuffix but worded for booking assistance.
  ContactLocalOfficeForBookingHelp = 'Please contact your local Stena Line office if you need booking assistance.',

  // TODO: three "You do not have access to ..." wordings (page / booking / Information.NoAccessToFeatureHeading).
  NoAccessToPage = 'You do not have access to this page.',
  NoAccessToBooking = 'You do not have access to this booking',

  SelectSecondBooking = 'Select second booking',

  // TODO: prefix only — type label is interpolated at the call site (CustomsLinkPopupContent.tsx).
  AddVehicleRegToCreatePrefix = 'Add vehicle registration number to create',

  // TODO: cluster of "X is required" validation messages used in valibot schemas (services/intermodal/validation/schemas.ts).
  IntermodalGoodsTypeRequired = 'Goods type is required',
  IntermodalGoodsWeightRequired = 'Goods weight is required',
  IntermodalRouteRequired = 'Route is required',
  IntermodalAccountRequired = 'Account is required',
  IntermodalDateRequired = 'Date is required',
  IntermodalTimeRequired = 'Time is required',
  IntermodalVehicleTypeRequired = 'Vehicle type is required',
  IntermodalLengthRequired = 'Length is required',
  IntermodalWidthRequired = 'Width is required',
  IntermodalHeightRequired = 'Height is required',
  IntermodalEmptyWeightRequired = 'Empty weight is required',
}
